import React, { useEffect } from 'react';
import TransportPageLayout from '../../components/transportation/TransportPageLayout';
import { ScheduleCard, TimesList, RatesTable } from '../../components/transportation/TransportUI';
import { setSeoMetadata } from '../../lib/seo';

const WestinFerryPage = () => {
  useEffect(() => {
    setSeoMetadata({
      title: 'Westin Ferry Information | Westin Guest Transportation | St John USVI',
      description:
        'Schedule, rates and booking info for the private Westin St John resort ferry between the airport / Red Hook and the Westin Resort. For Westin guests only.',
      keywords: 'westin ferry st john, westin resort transportation, red hook to westin ferry',
      canonicalPath: '/st-john-vi-westin-ferry-information',
      ogType: 'website',
    });
  }, []);

  return (
    <TransportPageLayout title="Westin Ferry Information" subtitle="Westin ↔ Red Hook" adId="westin-ferry">
      <p className="text-center font-semibold text-slate-800">This ferry is for Westin Guests Only.</p>

      <p className="text-center text-slate-700 leading-relaxed">
        The easiest way to get to the Westin Resort is to use their transportation package. The Westin maintains an
        office in the baggage claim area at the airport, where you may sign up for the package while waiting for your
        luggage.
      </p>

      <p className="text-center text-slate-700">
        Call the Westin direct to book:{' '}
        <a href="tel:13406938000" className="font-bold text-red-600 hover:underline" data-testid="westin-ferry-phone">
          (340) 693-8000
        </a>
      </p>

      <ScheduleCard
        testId="westin-ferry-schedule"
        first
        operator={{ operatedBy: 'The Westin St John', phones: ['(340) 693-8000'], location: '300A Chocolate Hole', travelTime: '30-35 minutes' }}
      >
        <div className="grid gap-6 sm:grid-cols-2">
          <TimesList label="Depart Westin" times={['5:00 AM', '7:00 AM', '8:00 AM', '10:00 AM (Shopping)', '11:45 AM', '2:45 PM', '4:45 PM', '5:45 PM', '8:45 PM', '11:40 PM']} />
          <TimesList label="Depart Red Hook" times={['5:30 AM', '7:30 AM', '8:30 AM', '11:00 AM', '2:15 PM', '4:00 PM (Shopping)', '5:15 PM', '7:00 PM', '10:30 PM']} />
        </div>
        <RatesTable rates={[['Adult Guest, round trip', '$132.00'], ['Youth (Ages 4-17)', '$95.00'], ['Owners (owner + one)', '$120.00'], ['One-Way, all ages', '$75.00']]} />
        <p className="text-xs text-slate-500">Children 3 and under are free.</p>
      </ScheduleCard>

      <p className="text-center text-slate-700 leading-relaxed">
        If you choose the private Westin ferry service, you’ll check in at the Westin reception desk at the airport
        and leave your luggage with Westin staff for direct transport to your villa. You’ll enjoy the approx.
        45-minute ride from the airport to the Red Hook ferry terminal in an enclosed, air-conditioned van equipped
        with WiFi.
      </p>
    </TransportPageLayout>
  );
};

export default WestinFerryPage;
